export default "__VITE_ASSET__BQZ3$uLb__"